export default __webpack_public_path__ + "static/media/ico_project_save.c87d11af.svg";